import _ from 'lodash'
import $ from 'jquery'
import Backbone from 'backbone'
import datasetPaths from './dataset-paths'
import PathToDatasetSelector from './path-to-dataset-selector'
import appDisplay from 'scoreboard/components/app-display'
import i18n from 'scoreboard/components/i18n'
import icon from 'scoreboard/components/icon'
import TruncatedTooltip from 'scoreboard/components/truncated-tooltip'

const PathToDatasetButton = Backbone.View.extend({

	/**
	 * Renders a button that can be used to choose a path to a dataset.
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Dataset} options.model
	 *
	 * @param {Object} [options.path] an existing path to a dataset to be
	 * pre-selected, if appropriate
	 *
	 * @param {Function} datasetIdRetriever a function that returns the ID of the
	 * dataset we're choosing a path to
	 */
	initialize: function(options = {}) {
		this.options = options
		this.path = options.path
		this.datasetId = datasetPaths.lastDatasetId(options.path)
	},

	events: {
		'click': 'onClick'
	},

	/** @type {Dataset} */
	model: null,

	tagName: 'button',

	className: 'button button-default path-to-dataset-button button-nowrap button-right-icon',

	render: function() {
		this.updateLabel(this.options.path)
		this.$el.attr('type', 'button')
		return this
	},

	/**
	 * Launches a dialog where the user can select the path to the dataset
	 */
	onClick: function() {
		let form = new PathToDatasetSelector({
			model: this.model,
			id: this.options.path,
			datasetId: this.options.datasetIdRetriever()
		})
		appDisplay.dialog(form)
		form.on('done', datasetPath => {
			this.path = datasetPath.id
			this.updateLabel(this.path)
			this.datasetId = datasetPaths.lastDatasetId(this.path)
			this.trigger('change:dataset', this.datasetId)
		})
	},

	/**
	 * @param path something like 252_2264,251_2312, where the first
	 * number before an underscore is the dataset ID and the second
	 * number is the field ID
	 */
	updateLabel: function(path) {
		let text
		if (_.isNil(path)) {
			text = i18n.get('datasets.linked.choosePathToDataset') + '...'
			this.$el.html(_.escape(text) + icon('edit'))
		} else {
			let datasetsAndFields = datasetPaths.datasetsAndFields(this.model, path)
			// something like ['SHARP (Subject)', 'SHARP (Victim)']
			let linkDescriptions = _.map(datasetsAndFields, 'label')
			// build the HTML structure for the button content.
			// Content will be something like SHARP (Subject) > SHARP (Victim)
			let total = linkDescriptions.length
			if (total > 1) {
				let buttonContent = $('<span class="choose-dataset-path"></span>')
				_.forEach(linkDescriptions, (link, count) => {
					let last = count + 1 === total
					let separator = !last ? '>' : ''
					let linkedField = last ? 'class="linked-field"' : ''
					let pathOpenTag = count === 0 ? '<span class="path">' : ''
					let pathCloseTag = last ? '</span>' : ''
					let editIcon = last ? icon('edit') : ''
					buttonContent.append($(`${pathOpenTag} <span ${linkedField}> ${_.escape(link)}</span> ${separator}${pathCloseTag} ${editIcon}`))
				})
				this.$el.html(buttonContent)
				let linkedFieldWidth = _.round(this.$('.linked-field').width())
				// If content is overflowing button, truncate the path and allow the linked field to be fully displayed.
				// If truncating occurs, we will add a tooltip showing the full path on hover.
				this.$('.path').css('max-width', `calc(100% - ${linkedFieldWidth + 2}px)`)
			} else {
				this.$el.html(`<span class="choose-dataset-path linked-field">${_.escape(linkDescriptions)} ${icon('edit')}</span>`)
			}
			this.truncatedTooltip = new TruncatedTooltip({
				el: this.$('.choose-dataset-path'),
				multipleTextEls: total > 1 ? this.$('.path, .linked-field') : false
			 }).render()
		}
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.truncatedTooltip], 'remove')
	}
})

export default PathToDatasetButton

PathToDatasetButton.__filename__ = 'datasets/edit/path-to-dataset-button.js'
